export default __webpack_public_path__ + "images/albinotonnina.com.mp4";